<template>
  <!-- NOTE (TEMPLATE) to show all proposals -->

  <div class="animated fadeIn">
    <b-card
      v-if="$router.currentRoute.path == '/researcher/deactiveUnirequests'"
      style="border: 0"
      class="mt-0 mb-0"
    >
      <h6>
        <b-input-group size="md">
          <b-form-input
            trim
            v-model="filter"
            type="search"
            id="filterInput"
            placeholder="جستجو"
          ></b-form-input>
          <b-input-group-append>
            <b-button :disabled="!filter" @click="filter = ''" variant="danger"
              >حذف</b-button
            >
          </b-input-group-append>
        </b-input-group>
      </h6>

      <!-- NOTE (t-proposals) to show all proposals -->
      <b-table
        responsive
        show-empty
        head-variant="dark"
        :fields="fields"
        :items="computedItems"
        empty-text="هنوز مقاله‌ای ثبت نشده است"
        striped
        :busy="isBusy"
        :filter="filter"
      >
        <template v-slot:head()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.label }}
          </div>
        </template>
        <template v-slot:cell()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value }}
          </div>
        </template>
        <template v-slot:cell(faSubject)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value ? data.value : "-" }}
          </div>
        </template>
        <template v-slot:cell(registerDate)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value ? data.value : "-" }}
          </div>
        </template>
        <template v-slot:cell(status)="data">
          <div
            v-if="data.item.status == 'پیش نویس'"
            style="text-align: center; vertical-align: middle"
          >
            <b-button class="btn btn-pill btn-yahoo p-2" disabled
              >پیش نویس</b-button
            >
          </div>
          <div
            v-if="data.item.status == 'لغو'"
            style="text-align: center; vertical-align: middle"
          >
            <b-button class="btn btn-pill btn-reddit p-2" disabled
              >لغو شده</b-button
            >
          </div>
          <div
            v-if="data.item.status == 'رد شده است'"
            style="text-align: center; vertical-align: middle"
          >
            <b-button class="btn btn-pill btn-youtube p-2" disabled
              >رد شده</b-button
            >
          </div>
        </template>
        <template v-slot:cell(index)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.index + 1 }}
          </div>
        </template>
        <div slot="table-busy" class="text-center tableDarkText my-2">
          <strong>در حال بارگذاری...</strong>
          <br />
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </b-table>
    </b-card>
    <b-modal
      id="secondStep"
      ref="secondStep"
      header-bg-variant="primary"
      header-text-variant="white"
      class="text-center border-0"
      size="md"
      centered
    >
      <template v-slot:modal-header class="border-0">
        <h4>بخش دوم</h4>
      </template>
      <template v-slot:modal-footer>
        <b-row>
          <b-col cols="1"></b-col>
          <b-col cols="10">
            <!-- NOTE (b-doDeleteColleague) to confirm the Colleague removal -->
            <b-button
              variant="primary"
              size="lg"
              @click="gotoSecondStep(selectedItem)"
              >شروع بخش دوم</b-button
            >
          </b-col>
          <b-col cols="1"></b-col>
        </b-row>
      </template>
      <h5 class="text-primary px-2">دانشجوی محترم</h5>
      <h5 class="px-2 pt-2">
        با توجه به تایید بخش اول لطفا جهت ادامه روند ثبت رساله اطلاعات بخش دوم
        را تکمیل نمایید.
      </h5>
    </b-modal>
    <b-modal
      id="noSecondStep"
      ref="noSecondStep"
      header-bg-variant="primary"
      header-text-variant="white"
      class="text-center border-0"
      size="md"
      centered
    >
      <template v-slot:modal-header>
        <h4>بخش دوم</h4>
      </template>
      <template v-slot:modal-footer>
        <b-row>
          <b-col cols="1"></b-col>
          <b-col cols="10">
            <!-- NOTE (b-doDeleteColleague) to confirm the Colleague removal -->
            <b-button variant="primary" size="lg" @click="hideModal()"
              >تایید</b-button
            >
          </b-col>
          <b-col cols="1"></b-col>
        </b-row>
      </template>
      <h5 class="text-primary px-2">دانشجوی محترم</h5>
      <h5 class="px-2 pt-2">
        شما اجازه دسترسی به این بخش را ندارید. لطفا تا زمان تغییر وضعیت به وضعیت
        " تایید شده" منتظر بمانید.
      </h5>
      <h5 class="text-primary pt-2 px-2">با تشکر از صبوری شما</h5>
    </b-modal>
    <router-view></router-view>
  </div>
</template>

<script>
import router from "../../router"; // NOTE (IMPORT) to communication between different parts of the site

export default {
  components: {},
  data: function () {
    return {
      fields: [
        { key: "index", label: "ردیف" },
        { key: "faSubject", label: "عنوان فارسی" },
        { key: "requestsCode", label: "کد درخواست" },
        { key: "registerDate", label: "تاریخ ثبت" },
        { key: "status", label: "وضعیت" },
        { key: "university", label: "دانشگاه" },
        { key: "version", label: "نسخه" },
        { key: "lastUpdate", label: "آخرین بروزرسانی" },
      ],
      // items: [{ faSubject: 'test1' , status: 'نیاز به تکمیل'}, { faSubject: 'test2', status: 'ثبت شده' }],
      items: [],
      filter: "",
      isBusy: true,
      selectedItem: "",
    };
  },
  watch: {
    $route: function () {
      this.getData();
    },
  },
  methods: {
    showModal(item) {
      this.selectedItem = item;
      if (item.status == "تایید شده") {
        this.$refs["secondStep"].show();
      } else {
        this.$refs["noSecondStep"].show();
      }
    },
    hideModal() {
      this.$refs["noSecondStep"].hide();
    },

    getData() {
      // NOTE (m-getData) to get proposals data to show them
      this.isBusy = true;
      this.$http
        .get(this.baseUrl + "/setad/researcher/unirequests/inactives", {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("userId"),
          },
        })
        .then((res) => {
          this.items = res.data;
          this.isBusy = false;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.isBusy = false;
        });
    },
    gotoSecondStep(item) {
      router.push("/researcher/master2ndStep/:id");
    },

    cancelProposal(item) {
      // NOTE (m-cancelProposal) to cancel a proposal
      this.isBusy = true;
      this.$http
        .post(
          this.baseUrl + "/setad/researcher/request/article/cancel",
          {
            requestId: item.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.toast(res.data, "success");
          this.getData();
        })
        .catch((err) => {
          this.toast(
            err.response.data + ". لطفا با پشتیبانی تماس بگیرید.",
            "error"
          );
          this.isBusy = false;
        });
    },
  },
  computed: {
    computedItems() {
      if (this.items) {
        return this.items.sort((a, b) => {
          if (a.time < b.time) {
            return 1;
          }
          if (a.time > b.time) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });
      } else return [];
    },
  },
  updated() {
    // NOTE (UPDATED) to get data and show them
    // this.getData();
  },
  mounted() {
    // NOTE (MOUNTED) to get data and show them at the beginning
    this.getData();
  },
};
</script>
<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
.bg-primary {
  background-color: #693d70 !important;
}

.btn-light {
  color: #fff !important;
  background-color: #63317c !important;
  border-color: #63317c !important;
}
.btn-success {
  color: #fff !important;
  background-color: #4dbd74 !important;
  border-color: #4dbd74 !important;
}
.btn-primary {
  color: #fff;
  background-color: #20a8d8 !important;
  border-color: #20a8d8 !important;
}
.btn-danger {
  color: #fff !important;
  background-color: #f86c6b !important;
  border-color: #f86c6b !important;
}
.color {
  background-color: #0c4961;
  color: white;
}
</style>
